module.exports = __webpack_public_path__ + "static/media/search-black.3fb9f3e1.svg";